import * as React from 'react'
import cn from 'classnames'
import styles from './media.module.scss'

import logo1 from './logos/logo-1.png'
import logo2 from './logos/logo-2.png'
import logo3 from './logos/logo-3.png'
import logo4 from './logos/logo-4.png'

interface IMediaProps {
  larger?: boolean
}

const Media = ({ larger }: IMediaProps) => {
  const logos = [
    {
      name: 'Breakit',
      img: logo1,
      cn: styles.Breakit,
    },
    {
      name: 'NyTeknik',
      img: logo2,
      cn: styles.NyTeknik,
    },
    {
      name: 'Revisionsvärlden',
      img: logo3,
      cn: styles.Revisionsvärlden,
    },
    {
      name: 'DiDigital',
      img: logo4,
      cn: styles.DiDigital,
    },
  ]

  return (
    <div className={cn(styles.root, larger && styles.larger)}>
      <div className={styles.logos}>
        {logos.map((logo) => (
          <React.Fragment key={`${logo.name}`}>
            <img alt={`${logo.name}`} className={logo.cn} src={logo.img} />
            <div className={styles.dot} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default Media
